import PptxGenJS from 'pptxgenjs'
import { splitTextInRect } from 'shared/util'
import { TagResultList } from 'interface/kojin/log'

import { slideFrom } from '../util/slideFrom'
import { KojinPptxComponentsProps } from '../types'

const drugScoreLayout = {
  column: {
    drugNameWidth: 4,
    scoreWidth: 0.5,
  },
  lineHeight: 0.2,
  margin: { cx: 0.1, cy: 0.05 },
}
const enableHeaderTextColor = '000000'
const enableHeaderBackground = { color: 'e3cbcd' }
const enableScoreTextColor = '000000'
const enableScoreBackground = { color: 'f1e7e8' }
const disableTextColor = 'bcbdc0'
const disableBackground = { color: 'f4f4f4' }

const borderColor = 'ffffff'

type drugScoreTableProps = KojinPptxComponentsProps & {
  drugTags: TagResultList[]
  top: number
}
type drugScoreTableReturnValue = {
	slide: PptxGenJS.Slide
  bottom: number
}
export const drugScoreTable = ({
  drugTags,
  top,
  ...other
}: drugScoreTableProps): drugScoreTableReturnValue => {
  const { layout, slide, search } = other
  if (!search.drug || search.drug.length === 0) return { slide, bottom: top }
  if (drugTags.length === 0) return { slide, bottom: top }

  let scoreMax = 0
  const rows: PptxGenJS.TableRow[] = search.drug.map(
    drug => {
      const score = drug.drugName
        .split('/')
        .reduce(
          (m, drugName) =>
            drugTags.reduce((n, tag) => {
              if (tag.tag === drugName) return n + tag.count
              return n
            }, m),
          0
        )
      scoreMax = Math.max(scoreMax, score)
      return [{
        text: drug.drugName,
        width: drugScoreLayout.column.drugNameWidth,
        options: {
          ...layout.cellOption,
          fill: score > 0 ? enableHeaderBackground : disableBackground,
          color: score > 0 ? enableHeaderTextColor : disableTextColor,
        }
      }, {
        text: score > 0 ? `${score}` : '-',
        width: drugScoreLayout.column.scoreWidth,
        options: {
          ...layout.cellOption,
          fill: score > 0 ? enableScoreBackground : disableBackground,
          color: score > 0 ? enableScoreTextColor : disableTextColor,
          align: 'center',
        }
      }]
    }
  )
  if (scoreMax === 0) return { slide, bottom: top }

  const widths = [
    drugScoreLayout.column.drugNameWidth,
    drugScoreLayout.column.scoreWidth,
  ]
  const height = rows.reduce((h, row) => {
    let j = 0
    return (
      h +
      row.reduce((h, col) => {
        const columnWidth =
          widths[j] - (drugScoreLayout.margin.cx + drugScoreLayout.margin.cx)
        const text = typeof col.text === 'string' ? col.text ?? '' : ''
        const lines =
          splitTextInRect(
            text,
            layout.baseFont.fontSize,
            layout.baseFont.fontFace,
            columnWidth * layout.inchPerDot
          ) || []
        j += col.options?.colspan ?? 1
        return Math.max(
          h,
          drugScoreLayout.margin.cy +
            drugScoreLayout.lineHeight * lines.length +
            drugScoreLayout.margin.cy
        )
      }, 0)
    )
  }, 0)

  slide.addTable(rows, {
    x: slideFrom(
      layout,
      'right',
      drugScoreLayout.column.drugNameWidth + drugScoreLayout.column.scoreWidth
    ),
    y: top + layout.margin,
    colW: widths,
    border: { pt: 1, color: borderColor },
  })
  return {
    slide,
    bottom: top + layout.margin + height,
  }
}
